import { Box, Chip, Stack, Typography } from '@mui/material'
import { UIStatus } from '../../../../store/waterQualityIndex'

interface VerdictCardProps {
  waterSafetyStatus: UIStatus
  topParameter: string | null
}

const HEADLINE: Record<UIStatus, string> = {
  unsafe: 'Your water has issues that need immediate attention.',
  cautious: 'Your water is mostly safe — but a few things need your attention.',
  safe: "Your water looks good — here's how to keep it that way.",
}

const CHIP_STYLES: Record<
  UIStatus,
  { label: string; sx: Record<string, string> }
> = {
  unsafe: {
    label: 'Unsafe',
    sx: { color: 'error.main', borderColor: 'error.main', bgcolor: 'error.light' },
  },
  cautious: {
    label: 'Cautious',
    sx: { color: 'warning.dark', borderColor: 'warning.main', bgcolor: 'warning.light' },
  },
  safe: {
    label: 'Safe',
    sx: { color: 'success.dark', borderColor: 'success.main', bgcolor: 'success.light' },
  },
}

export const VerdictCard = ({ waterSafetyStatus }: VerdictCardProps) => {
  const chip = CHIP_STYLES[waterSafetyStatus]

  return (
    <Box
      sx={{
        p: { xs: 2.5, md: 3 },
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        width: '100%',
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1.5}
        flexWrap="wrap"
        sx={{ mb: 1 }}
      >
        <Typography
          sx={{ typography: { xs: 'h4', md: 'h3' }, flex: 1, minWidth: 0 }}
        >
          {HEADLINE[waterSafetyStatus]}
        </Typography>
        <Chip
          variant="outlined"
          size="small"
          label={chip.label}
          sx={chip.sx}
        />
      </Stack>
      <Typography variant="body2" color="text.secondary">
        Based on your test results and local utility data — here&apos;s your full picture.
      </Typography>
    </Box>
  )
}
